module.exports = __webpack_public_path__ + "static/media/spain.38869900.svg";